var _g, _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChanges = function SvgChanges(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 570,
    height: 682,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421 178h46v44h-39a7 7 0 0 1-7-7v-37Z",
    fill: "url(#changes_svg__a)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421,
    y: 133,
    width: 89,
    height: 89,
    rx: 7,
    fill: "url(#changes_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 140a7 7 0 0 1 7-7h75a7 7 0 0 1 7 7v75a7 7 0 0 1-7 7h-75a7 7 0 0 1-7-7v-75Z",
    fill: "url(#changes_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 293h46v44h-39a7 7 0 0 1-7-7v-37Z",
    fill: "url(#changes_svg__d)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421,
    y: 248,
    width: 89,
    height: 89,
    rx: 7,
    fill: "url(#changes_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 255a7 7 0 0 1 7-7h75a7 7 0 0 1 7 7v75a7 7 0 0 1-7 7h-75a7 7 0 0 1-7-7v-75Z",
    fill: "url(#changes_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 408h46v44h-39a7 7 0 0 1-7-7v-37Z",
    fill: "url(#changes_svg__g)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421,
    y: 363,
    width: 89,
    height: 89,
    rx: 7,
    fill: "url(#changes_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 370a7 7 0 0 1 7-7h75a7 7 0 0 1 7 7v75a7 7 0 0 1-7 7h-75a7 7 0 0 1-7-7v-75Z",
    fill: "url(#changes_svg__i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 523h46v44h-39a7 7 0 0 1-7-7v-37Z",
    fill: "url(#changes_svg__j)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421,
    y: 478,
    width: 89,
    height: 89,
    rx: 7,
    fill: "url(#changes_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 485a7 7 0 0 1 7-7h75a7 7 0 0 1 7 7v75a7 7 0 0 1-7 7h-75a7 7 0 0 1-7-7v-75Z",
    fill: "url(#changes_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 638h46v44h-39a7 7 0 0 1-7-7v-37Z",
    fill: "url(#changes_svg__m)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421,
    y: 593,
    width: 89,
    height: 89,
    rx: 7,
    fill: "url(#changes_svg__n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 600a7 7 0 0 1 7-7h75a7 7 0 0 1 7 7v75a7 7 0 0 1-7 7h-75a7 7 0 0 1-7-7v-75Z",
    fill: "url(#changes_svg__o)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 83,
    r: 83,
    fill: "url(#changes_svg__p)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 450,
    y: 293,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 466,
    y: 307,
    width: 74,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 466,
    y: 321,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 520,
    y: 321,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 466,
    y: 333,
    width: 60,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 450,
    y: 349,
    width: 74,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 450,
    y: 177,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 466,
    y: 191,
    width: 74,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 466,
    y: 205,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 520,
    y: 205,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 466,
    y: 217,
    width: 60,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 450,
    y: 233,
    width: 74,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 86,
    width: 72.131,
    height: 7.213,
    rx: 3.607,
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 79.082,
    y: 106.197,
    width: 106.754,
    height: 7.213,
    rx: 3.607,
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 79.082,
    y: 126.393,
    width: 72.131,
    height: 7.213,
    rx: 3.607,
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 156.984,
    y: 126.393,
    width: 72.131,
    height: 7.213,
    rx: 3.607,
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 79.082,
    y: 143.705,
    width: 86.557,
    height: 7.213,
    rx: 3.607,
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 166.787,
    width: 106.754,
    height: 7.213,
    rx: 3.607,
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 450,
    y: 401,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 466,
    y: 415,
    width: 74,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 466,
    y: 429,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 520,
    y: 429,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 466,
    y: 441,
    width: 60,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 450,
    y: 457,
    width: 74,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 450,
    y: 523,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 466,
    y: 537,
    width: 74,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 466,
    y: 551,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 520,
    y: 551,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 466,
    y: 563,
    width: 60,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 450,
    y: 579,
    width: 74,
    height: 5,
    rx: 2.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.002 106C94.551 174.33 199.5 353 413 291.772",
    stroke: "url(#changes_svg__q)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.002 106C94.552 174.33 244 290.5 413 186.5",
    stroke: "url(#changes_svg__r)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.002 106C94.552 262.026 157.52 565.302 413 530.197",
    stroke: "url(#changes_svg__s)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.002 106C94.552 262.026 157.52 565.302 413 530.197",
    stroke: "url(#changes_svg__t)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.002 106C94.552 216.351 157.52 430.846 413 406.017",
    stroke: "url(#changes_svg__u)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.002 106C94.552 262.026 157.52 565.302 413 530.197",
    stroke: "url(#changes_svg__v)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.002 106C94.552 308.432 157.52 701.91 413 656.363",
    stroke: "url(#changes_svg__w)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__a",
    x1: 444,
    y1: 178,
    x2: 444,
    y2: 222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__b",
    x1: 465.5,
    y1: 133,
    x2: 465.5,
    y2: 222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__c",
    x1: 465.5,
    y1: 133,
    x2: 465.5,
    y2: 222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__d",
    x1: 444,
    y1: 293,
    x2: 444,
    y2: 337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__e",
    x1: 465.5,
    y1: 248,
    x2: 465.5,
    y2: 337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__f",
    x1: 465.5,
    y1: 248,
    x2: 465.5,
    y2: 337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__g",
    x1: 444,
    y1: 408,
    x2: 444,
    y2: 452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__h",
    x1: 465.5,
    y1: 363,
    x2: 465.5,
    y2: 452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__i",
    x1: 465.5,
    y1: 363,
    x2: 465.5,
    y2: 452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__j",
    x1: 444,
    y1: 523,
    x2: 444,
    y2: 567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__k",
    x1: 465.5,
    y1: 478,
    x2: 465.5,
    y2: 567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__l",
    x1: 465.5,
    y1: 478,
    x2: 465.5,
    y2: 567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__m",
    x1: 444,
    y1: 638,
    x2: 444,
    y2: 682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__n",
    x1: 465.5,
    y1: 593,
    x2: 465.5,
    y2: 682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__o",
    x1: 465.5,
    y1: 593,
    x2: 465.5,
    y2: 682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__p",
    x1: 83,
    y1: 0,
    x2: 83,
    y2: 166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__q",
    x1: 417.962,
    y1: 291.28,
    x2: 85.659,
    y2: 151.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__r",
    x1: 417.962,
    y1: 291.28,
    x2: 85.659,
    y2: 151.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__s",
    x1: 417.962,
    y1: 529.071,
    x2: 39.975,
    y2: 459.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__t",
    x1: 417.962,
    y1: 529.071,
    x2: 39.975,
    y2: 459.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__u",
    x1: 417.962,
    y1: 405.221,
    x2: 51.907,
    y2: 310.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__v",
    x1: 417.962,
    y1: 529.071,
    x2: 39.975,
    y2: 459.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "changes_svg__w",
    x1: 417.962,
    y1: 654.903,
    x2: 34.902,
    y2: 600.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};

export { SvgChanges as ReactComponent };
export default "data:image/svg+xml;base64,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";